export { default as createSvgIcon, IconDirectionality } from './createSvgIcon';
